/* GASSISA
=========================================================================================
* Descripción: Item de menú del sistema
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 21/03/2026 | Lic. José Luis Aragón Cervantes  | Regeneración completa
* ---------------------------------------------------------------------------------------
*/

import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ListItem, ListItemButton, ListItemText } from "@mui/material";
import { Link } from "react-router-dom";
import { useConfiguracion } from "../../context/System/ConfiguracionContext";
import { useLayout } from "../../context/System/LayoutContext";

export default function SizeSoftXMenuItem({ children, icon, route, clavePagina, disabled = true, hotkey }) {
    const { handleCloseMenuClient, clavePaginaActual } = useLayout();
    const { theme } = useConfiguracion();
    const sColorFuentes = theme?.palette?.kyngblue?.contrastText;

    const navigation = useNavigate();
    const paginaActual = clavePaginaActual === clavePagina;
    // const bgColor = theme?.palette?.orange?.main;
    const bgColor = theme?.palette?.kyngblue?.main;

    const handleKeyDown = useCallback((event) => {
        if (!disabled && event.altKey && event.key.toLowerCase() === hotkey?.toLowerCase()) {
            event.preventDefault();
            handleCloseMenuClient();
            navigation(route);
        }
    }, [hotkey, disabled, route, navigation, handleCloseMenuClient]);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);

    return (
        <Link to={route} style={{ textDecoration: "none", color: "initial", display: "block", width: "100%" }}>
            <ListItem
                disablePadding
                onClick={handleCloseMenuClient}
                sx={{
                    backgroundColor: bgColor ?? "transparent",
                    width: "100%",
                    overflowX: "hidden",
                    boxSizing: "border-box",
                }}
            >
                <ListItemButton 
                    disabled={disabled} 
                    sx={{
                        width: "calc(100% - 10px)",
                        mx: "5px",
                        boxSizing: "border-box",
                        pl: 4,
                        pr: 1,
                        py: 0.35,
                        minHeight: 32,
                        borderRadius: "5px",
                        overflowX: "hidden",
                        "&:hover": {
                            backgroundColor: "rgba(255,255,255,0.12)",
                        },
                    }}
                >
                    <ListItemText
                        primary={children}
                        sx={{
                            minWidth: 0,
                            "& .MuiListItemText-primary": {
                                fontSize: "1rem",
                                color: sColorFuentes,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                        }}
                    />
                </ListItemButton>
            </ListItem>
        </Link>
    );
}
